import ClubListItem from './ClubListItem'
import { useGetClubsQuery } from '../../features/SpeechAgendaApiSlice.ts'
import { useSetTitle } from '../../app/hooks/UseSetTitle.ts'
import { Club } from '../../generated'
import ClubRowSkeletonListItem from '../../components/skeletons/ClubRowSkeletonListItem.tsx'

export default function Clubs() {
  useSetTitle('Clubs on Speech Agenda')

  let clubs: Club[] | undefined
  const { data, isLoading, isFetching } = useGetClubsQuery()
  clubs = data

  if (isLoading || isFetching) {
    return (
      <ul role="list" className="divide-y divide-gray-100">
        {[...Array(3)].map((_, index) => (
          <ClubRowSkeletonListItem key={index} />
        ))}
      </ul>
    )
  }

  if (!clubs || clubs.length === 0) {
    clubs = []
  }

  return (
    <ul role="list" className="divide-y divide-gray-100">
      {clubs.map((club) => {
        return <ClubListItem club={club} key={club.id} />
      })}
    </ul>
  )
}
